import S from 'string';

angular.module('AccountingBoxApp')
    .filter('propsFilter', function() {
        return function(items, props) {
            var out = [];

            if (angular.isArray(items)) {
                items.forEach(function(item) {
                    var itemMatches = false;

                    var keys = Object.keys(props);
                    for (var i = 0; i < keys.length; i++) {
                        var prop = keys[i];
                        var text = props[prop].toLowerCase();
                        var p = prop.split('.');
                        var itemProp;
                        if (p.length == 2) {
                            itemProp = item[p[0]]
                          if(itemProp) {
                            itemProp = itemProp[p[1]];
                          }
                        } else {
                            itemProp = item[p[0]];
                        }
                      //  console.log('itemprop: itemprop',itemProp);
                        if (itemProp instanceof Array) {
                            var matches = _.filter(
                                itemProp,
                                function(st) {
                                  var str =  S(st.toString().toLowerCase()).latinise().s;
                                    return str.indexOf(text)!== -1;
                                }
                            );
                            if(matches.length>0){
                               itemMatches = true;
                               break;
                            }
                        }else{

                        if (itemProp) {
                             var str = S(itemProp.toString().toLowerCase()).latinise().s ;
                            if(str.indexOf(text) !== -1){
                            itemMatches = true;
                            break;
                        }
                        }
                      }
                    }

                    if (itemMatches) {
                        out.push(item);
                    }
                });
            } else {
                // Let the output be the input untouched
                out = items;
            }

            return out;
        };
    });

// angular.module('AccountingBoxApp')
//   .filter('propsFilter', function() {
//       return function(items, props) {
//           var out = [];
//
//           if (angular.isArray(items)) {
//                   // out = items.map(item => _.pick(item, ['users.*.name']))
//                   console.log('out',out[0])
//
//                   // const keys = Object.keys(props);
//                   // for (let i = 0; i < keys.length; i++) {
//                   //     let prop = keys[i];
//                   //     let text = props[prop].toLowerCase();
//                   //     console.log('prop',prop)
//                   //     console.log('text',text)
//                   //     console.log(_.filter(items, [prop, text]))
//                   //     out = _.filter(items, [prop, text])
//                   // }
//           } else {
//               // Let the output be the input untouched
//               out = items;
//           }
//
//           return out;
//       };
//   });
